export var isTextTrack=function(e){var r=e;return void 0!==r.activeCues&&void 0!==r.cues};